import PropTypes from 'prop-types'
import React from 'react'
import './callLogPopover.css'

const ContactToUpdate = ({
  contact,
  contact: {
    first_name: firstName,
    last_name: lastName,
    email,
  },
  handleClick,
}) => (
  <div>
    <div
      className="contactEntry"
      onClick={() => handleClick(contact)}
      role="button"
      tabIndex="-1"
    >
      <h3 className="contactText">{`${firstName} ${lastName} | ${email}`}</h3>
    </div>
    <div className="horizontalLine" />
  </div>
)

ContactToUpdate.propTypes = {
  contact: PropTypes.object.isRequired,
  handleClick: PropTypes.func.isRequired,
}

export default ContactToUpdate



// WEBPACK FOOTER //
// ./src/components/CallLog/ContactPopover/ContactToUpdate.js